export class StartupModel {
    id: string;
    status: string;
    name: string;
    industry: string;
    sector: string;
    fundedOrBoot: string;
    stage: string;
    interests: string;
    description: string;
    pitch: string;
    logo: string;
    state: string;
    city: string;
    email: string;
    mobile: string;
    website: string;
    mobileApp: string;
    webSource: string;

    // added fields

    StartupApply_FirstName: String;
    StartupApply_LastName: String
}

export class ImageUploadUrl {
    imgUrl: string;
}

export class StateModel {
    id: string;
    text: string;
    value: string;
}
export class CityModel {
    id: string;
    text: string;
    value: string;
}

export class IndustryModel {
    id: string;
    name: string;
    text: string;
    value: string;
}

export class SectorModel {
    id: string;
    name: string;
    text: string;
    value: string;
}